<template>
    <div class="row justify-content-center">
        <div class="col-lg-8 col-xl-6">
            <StepsPercentage percentage="width:85%;" outerClass="mb-4" />

            <div class="card bg-white">
                <div class="card-body border-0">
                    <div class="chat-help d-flex align-items-center mb-4">
                        <div class="chat-help-avatar">
                            <img src="/images/chat-help-image.jpg" class="rounded-circle">
                        </div>
                        <div class="chat-help-bubble ml-3">
                            Please enter your zipcode so we can check your eligibility based on your state
                        </div>
                    </div>
        
                    <form @submit.prevent="validateBeforeSubmit">
                        <fieldset class="mb-5">
                            <div class="row">
                                <div class="col-lg-6">
                                    <CleaveInput
                                        label="What's your zipcode?"
                                        id="zipcode"
                                        name="zipcode"
                                        maxlength="5"
                                        type="tel"
                                        v-model="zipcode"
                                        :cleaveoptions="masks.zipcode"

                                        v-validate="{ required: true, validateZip: true, regex: /^[0-9]{5}$/ }"
                                        :exval="validationAttempt"
                                        :error="errors.first('zipcode')" 
                                    />
                                </div>
                            </div>
                        </fieldset>
                        <div class="d-flex align-items-center">
                            <button class="btn btn-cta btn-red uc" id="form-submit">{{saving ? 'Saving...' : 'Continue'}}</button>
                            <div>
                                <transition name="slide">
                                    <span class="some-errors" v-if="(errors.items.length != 0 && validationAttempt)">You have some errors</span>
                                </transition>
                            </div>
                        </div>
                    </form>
                </div><!--End Card Body-->
            </div><!--End Card-->
        </div><!--End Col-->
    </div><!--End Row-->
</template>

<script>
import axios from 'axios';
import StepsPercentage from '@/components/form/StepsPercentage.vue';
import CleaveInput from '@/components/form/CleaveInput.vue';

import { mapGetters, mapActions } from "vuex";

export default {
    name: 'WizardStep5',
    title: 'Apply | Step 5',
    components:{
        StepsPercentage,
        CleaveInput
    },
    data() {
	  return {
            validationAttempt: false,
            saving: false,

			zipcode: '',

            masks: {
                zipcode: { numericOnly: true, blocks: [5] },
            }
        }
        
        
    },
    methods: {
        ...mapActions(['saveFormData']),
        validateBeforeSubmit() {
            this.saving = true;
            this.validationAttempt = true;
			this.$validator.validate().then((result) => {
        		if (result) {
					this.saveFormData({
                        'zipcode': this.zipcode,
						'step5': true,
                    });
                    this.$router.push({ path: '/apply/6' });
                }
                this.saving = false;
      		});
        },
    },
    computed: {
        ...mapGetters(["formData"]),
    },
    created(){
        this.zipcode = this.formData.zipcode || '';
  }
}
</script>